// @flow
import ContentEditable from './ContentEditable';

export default ContentEditable;